import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../Header/Header";
import { Sidebar } from "../Sidebar/Sidebar";
import { AuthContext } from "../../context/AuthContext";
import styles from "./Layout.module.scss";
import classNames from "classnames";

export const Layout = () => {
  const authContext = useContext(AuthContext);
  
  if (!authContext) {
    throw new Error("AuthContext must be used within an AuthProvider");
  }

  const { currentUser } = authContext;
  
  // Determine if organisation based on user type or route
  const isOrganisation = 
    currentUser?.userType === "organisation";

  return (
    <main className={classNames(styles.main, {
      [styles.orgMain]: isOrganisation
    })}>
      <Sidebar />
      <section className={classNames(styles.content, {
        [styles.orgContent]: isOrganisation
      })}>
        <Header />
        <Outlet />
      </section>
    </main>
  );
};

